/* eslint-disable @typescript-eslint/naming-convention */
import { EventEmitter, Injectable, OnInit } from '@angular/core';
import { StorageService } from './storage.service';
import { Dictionary } from '../helpers/dictionary';
import { environment } from '../../environments/environment';
import { filter, Observable, of, map } from 'rxjs';
@Injectable({
  providedIn: 'root',
})
export class StateService implements OnInit {
  public isFirstTimeLoaded = false;

  public state = new Dictionary();

  public stateChanged: EventEmitter<Dictionary> =
    new EventEmitter<Dictionary>();
  private STATE_KEY = environment.appPrefix + '_appstate';
  private DATE_KEY = 'lastSave';

  constructor(private localStorageService: StorageService) {
    localStorageService.getObject(this.STATE_KEY).then((stateFromStorage) => {
      stateFromStorage = JSON.parse(stateFromStorage);
      const dateString = stateFromStorage?.items?.[this.DATE_KEY];
      if (
        dateString &&
        new Date().valueOf() - new Date(dateString).valueOf() >=
          8 * 60 * 60 * 1000
      ) {
        //TODO logout??

        this.saveState();
      } else {
        if (stateFromStorage != null) {
          this.state.initializeItems(stateFromStorage.items);
        }
      }
    });
  }

  ngOnInit(): void {}

  public setValue(key: string, value: any) {
    this.state.set(key, value);
    this.saveState();
  }

  public getValue(key: string): any {
    return this.state.get(key);
  }

  public getValueTyped<TValue>(key: string): TValue | undefined {
    return this.state.get(key) as TValue | undefined;
  }

  public removeValue(key: string) {
    this.state.delete(key);
    this.saveState();
  }

  public clearState() {
    this.state = new Dictionary();
    this.saveState();
  }
  public waitForFirstTimeLoaded(): Observable<boolean> {
    if (this.isFirstTimeLoaded) {
      return of(true);
    }

    return of(false);
  }

  private saveState() {
    this.state.set(this.DATE_KEY, new Date());
    this.localStorageService.setObject(this.STATE_KEY, this.state);
    this.stateChanged.emit(this.state);
  }
}
